import React from 'react'

const Achievements = () =>{
    return(
        <>
            <h1> Achievements us page </h1>
        </>
    )
}
export default Achievements;